'use client';
import type { AddExperienceSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-add-experience-dialog';
import { JobportalAddExperienceDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-add-experience-dialog';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';
import { FaPlusCircle } from 'react-icons/fa';

type JobportalAddExperienceButtonProps = {
  className?: string;
  onJobAdded?: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const JobportalAddExperienceButton = ({ className }: JobportalAddExperienceButtonProps) => {
  const { t } = useTranslations();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const form = useFormContext<CreateCurriculumSchema>();

  const experiences = form.watch('experiences');

  const onAddExperienceSubmit = (data: AddExperienceSchemaType) => {
    form.setValue('experiences', [
      ...((form.getValues('experiences') as any[]) || []),
      { ...data },
    ]);
  };

  const handleAddExperienceClick = () => {
    openDialog({
      id: JobportalAddExperienceDialog.id,
      content: (
        <JobportalAddExperienceDialog
          onSubmit={onAddExperienceSubmit}
          newId={
            experiences && experiences.length > 0
              ? Math.max(...experiences.map((e: any) => e.id || 0)) + 1
              : 0
          }
        />
      ),
    });
  };

  return (
    <Button
      type={'button'}
      className="flex gap-3 sm:max-w-min"
      onClick={() => handleAddExperienceClick()}
    >
      <FaPlusCircle className={'h-6 w-6'} />
      <p className="whitespace-nowrap">{t('text951')}</p>
    </Button>
  );
};
